export const chart2023Gql = `... on landingPageContent2023_chart_BlockType {
  typeHandle
  pageTitle
  displayInHeaderQuicklinks
  id
  chartColumn {
    columnContent @markdown
    columnHeading
  }
}`;
